import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";

import type {
  CollectionCreateRequest,
  CollectionPreviewRequest,
  CollectionPreviewResponse,
  CollectionsSummaryList,
  CollectionUpdateRequest,
  ICollection,
  ICollectionOrderList,
  SavedCollectionPreviewRequest,
} from "./types";

export const collectionsApi = {
  async postNewCollection(data: CollectionCreateRequest) {
    const response = await apiClient.post<ICollection>(
      `${API_ENDPOINTS.ADMIN}/collections`,
      data
    );
    return response;
  },

  async previewCollection(
    data: CollectionPreviewRequest
  ): Promise<CollectionPreviewResponse> {
    return apiClient.post<CollectionPreviewResponse>(
      `${API_ENDPOINTS.ADMIN}/collections/preview`,
      data
    );
  },

  async previewSavedCollection(
    id: string,
    data: SavedCollectionPreviewRequest
  ): Promise<CollectionPreviewResponse> {
    return apiClient.post<CollectionPreviewResponse>(
      `${API_ENDPOINTS.ADMIN}/collections/${id}/preview`,
      data
    );
  },

  async getAllCollections(): Promise<CollectionsSummaryList> {
    const response = await apiClient.get<CollectionsSummaryList>(
      `${API_ENDPOINTS.ADMIN}/collections`
    );
    return response;
  },

  async patchCollection(id: string, data: CollectionUpdateRequest) {
    const response = await apiClient.patch(
      `${API_ENDPOINTS.ADMIN}/collections/${id}`,
      data
    );
    return response;
  },

  async deleteCollection(id: string) {
    const response = await apiClient.delete(
      `${API_ENDPOINTS.ADMIN}/collections/${id}`
    );
    return response;
  },

  async getCollectionById(id: string): Promise<ICollection> {
    const response = await apiClient.get<ICollection>(
      `${API_ENDPOINTS.ADMIN}/collections/${id}`
    );
    return response;
  },

  async deactivateCollection(id: string) {
    const response = await apiClient.patch(
      `${API_ENDPOINTS.ADMIN}/collections/${id}/deactivate`
    );
    return response;
  },

  async postCollectionOrder(data: ICollectionOrderList) {
    const response = await apiClient.patch<ICollectionOrderList>(
      `${API_ENDPOINTS.ADMIN}/collections/reorder`,
      data
    );
    return response;
  },
};
